const dinner = [
    {
        id: 1,
        name: 'Esparguete vegetariano',
        description: 'esparguete, cenoura, açafrão, repolho, couve ',
        price: '4.000'
    },
    {
        id: 2,
        name: 'Sopa de feijão',
        description: 'carne de vaca, couve, repolho, cenoura, feijão',
        price: '1.500'
    },
    {
        id: 3,
        name: 'Massa Carbonara',
        description: 'massa, bacon, ovos, queijo, sal, pimenta',
        price: '6.000'
    }
];

export default dinner;